module.exports = __webpack_public_path__ + "img/cross.77c1b467.svg";